import { useEffect } from "react";
import { useHeaderTitle } from "src/contexts/HeaderTitleContext";

const TitleWrapper = ({ title, children }) => {
  const { setHeaderTitle } = useHeaderTitle();

  useEffect(() => {
    setHeaderTitle(title);
  }, [title, setHeaderTitle]);

  return children;
};

export default TitleWrapper;
